import { toast } from 'react-toastify'
import { IBookingCalendarStore } from '../../index'
import { IToggleCalculate } from '../../../../actions/bookingCalendar/reservationModal/calculateEndPrice'

export default function(
  state: IBookingCalendarStore,
  action: IToggleCalculate,
): IBookingCalendarStore {
  if (!action.toggle) {
    toast.dismiss('recalculatePrice')
  }

  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      calculatingPrice: action.toggle,
    },
  }
}
